"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// 计算每个节点的深度，具有相同深度的节点，认为是处于同一级的节点
var scoreList = {};
function calculateScore(el, tiers, atttName) {
  if (!(scoreList[tiers] instanceof Array)) {
    scoreList[tiers] = [];
  }
  var childrenLen = el.children ? el.children.length : 0;
  if (childrenLen > 0) {
    for (var childs = el.children, len = childrenLen - 1; len >= 0; len--) {
      calculateScore(childs[len], tiers + 1, atttName);
    }
  }
  var tagMetric = el.getAttribute(atttName);
  if (tagMetric) {
    scoreList[tiers].unshift(tagMetric);
  }
}
var _default = function _default(atttName) {
  scoreList = {}; // 清空数据
  calculateScore(document.body, 1, atttName);
  // 清除空数组节点
  Object.keys(scoreList).forEach(function (item) {
    if (scoreList[item].length === 0) {
      delete scoreList[item];
    }
  });
  return scoreList;
};
exports.default = _default;